import { capitalize } from 'lodash';
import { TranslationValues } from 'next-intl';

export const timeAgo = (dateString: string, t: (word: any, obj?: TranslationValues) => string) => {
  if (!dateString) return '';

  const now = new Date();
  const date = new Date(dateString);
  const diffInSeconds = Math.abs(now.getTime() - date.getTime()) / 1000;

  const mins = Math.floor(diffInSeconds / 60);
  const hours = Math.floor(mins / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (dateString === '1970-01-01T00:00:00.000Z') return capitalize(t('time_ago.never'));

  if (years > 0) return capitalize(t('time_ago.year', { count: years }));

  if (months > 0) return capitalize(t('time_ago.month', { count: months }));

  if (weeks > 0) return capitalize(t('time_ago.week', { count: weeks }));

  if (days > 0) return capitalize(t('time_ago.day', { count: days }));

  if (hours > 0) return capitalize(t('time_ago.hour', { count: hours }));

  return capitalize(t('time_ago.minute', { count: mins }));
};
